var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.dialogModel,
      "title": _vm.$t('repairEstimate.response.makeOffer'),
      "subtitle": _vm.$t('repairEstimate.response.makeOfferSubtitle'),
      "supressKeyboardActions": true,
      "loading": _vm.loading,
      "rightLoading": _vm.loading || _vm.loadingRequestMoreData || _vm.loadingRespondReject,
      "rightDisabled": !_vm.isValid,
      "leftText": _vm.leftText,
      "rightText": _vm.rightText,
      "width": 1200
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.dialogModel = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.dialogModel = $event;
      },
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', {
    staticClass: "pt-1",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('drop-area-multi', {
    staticClass: "my-2",
    attrs: {
      "files": _vm.files,
      "text": _vm.$t('cost.dragAndDropDocuments'),
      "dragoverText": _vm.$t('sign.SignDocumentCreateDialog.title'),
      "loading": _vm.loading,
      "accept": ".pdf",
      "maxFiles": 1
    },
    on: {
      "update:files": function updateFiles($event) {
        _vm.files = $event;
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    ref: "startField",
    attrs: {
      "label": _vm.$t('objects.repairEstimate.number'),
      "hint": _vm.$t('objects.repairEstimate.numberHint'),
      "persistent-hint": true,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.valueCopy.number,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "number", $$v);
      },
      expression: "valueCopy.number"
    }
  })], 1)], 1), _c('line-items-form', {
    attrs: {
      "readonly": false,
      "showProducts": false
    },
    model: {
      value: _vm.valueCopy,
      callback: function callback($$v) {
        _vm.valueCopy = $$v;
      },
      expression: "valueCopy"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }